import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpJobs'

// LIST RESUME FRANCHISE
export const resumes = (params = '') => Http.get(`/user-profiles${serialize(params)}`)
